import { Component, OnInit, Input } from '@angular/core';
import { IWiedervorlageViewModel } from '../../home/home-wiedervorlage.model';
import { IDefaultSelectBoxViewModel } from '../../shared/models/default-selectBox.model';
import { AjaxService } from 'AjaxService';
import { AuthService } from 'AuthService';
import DataSource from 'devextreme/data/data_source';
import { EntityArt } from '@enums/entityArt.enum';
import { lastValueFrom } from 'rxjs';

interface ISearchRequestViewModel {
  ownerId: number;
  entityArt: EntityArt;
  onlySelfResults: boolean;
  searchText: string;
  skip: number;
  take: number;
  sortColumn: string;
  sortDirection: boolean;
}

@Component({
  selector: 'cz-wiedervorlagen',
  templateUrl: 'wiedervorlagen.component.html',
  styleUrls: ['wiedervorlagen.component.css'],
  standalone: false,
})
export class WiedervorlagenComponent implements OnInit {
  @Input() entityArt: EntityArt;
  @Input() ownerId: number;
  @Input() disabled: boolean = false;

  onlySelfResults: boolean = true;

  items: IWiedervorlageViewModel[];
  gruende: any[];
  benutzer: any[];
  currentUserId: number;
  dataSource: any = {};
  grundDataSource: any = {};

  constructor(
    private _ajaxService: AjaxService,
    private authService: AuthService
  ) {
    this.addCustomItem = this.addCustomItem.bind(this);
  }

  ngOnInit() {
    const self = this;

    this._ajaxService.get<IDefaultSelectBoxViewModel[]>('api/Wiedervorlagen/Gruende').subscribe((response) => {
      this.gruende = response.map((g) => {
        return { id: g.id, name: g.name };
      });
    });
    this._ajaxService.get<IDefaultSelectBoxViewModel[]>('api/Benutzer/GetAll').subscribe((response) => {
      this.benutzer = response.map((b) => {
        return { id: b.id, name: b.name };
      });
    });
    this.currentUserId = this.authService.getUserId();
    this.dataSource = new DataSource({
      load: function (loadOptions: any) {
        if (!loadOptions.searchOperation) {
          return;
        }

        const searchRequest: ISearchRequestViewModel = {
          ownerId: self.ownerId,
          entityArt: self.entityArt,
          onlySelfResults: self.onlySelfResults,
          searchText: loadOptions.filter && loadOptions.filter.length > 0 ? loadOptions.filter[0][2] : '',
          skip: loadOptions.skip,
          take: loadOptions.take,
          sortColumn: loadOptions.sort ? loadOptions.sort[0].selector : '',
          sortDirection: loadOptions.sort ? loadOptions.sort[0].desc : false,
        };

        return lastValueFrom(self._ajaxService.post<any>('api/Wiedervorlagen/Get', searchRequest)).then((response) => {
          return {
            data: response,
            totalCount: response.length,
          };
        });
      },
      insert: function (rowData) {
        const wiedervorlage = {
          entityArt: self.entityArt,
          benutzerId: rowData.benutzerId,
          betreff: rowData.betreff,
          ownerId: self.ownerId,
          grundId: rowData.grundId,
          termin: rowData.termin,
        } as IWiedervorlageViewModel;

        return lastValueFrom(self._ajaxService.post('api/Wiedervorlagen/Save', wiedervorlage)).then((response) => {
          return lastValueFrom(self._ajaxService.post<IWiedervorlageViewModel[]>('api/Wiedervorlagen/Get', { ownerId: self.ownerId, entityArt: self.entityArt })).then(
            (response) => {
              return {
                data: response,
                totalCound: response.length,
              };
            }
          );
        });
      },
      update: function (key, values) {
        const wiedervorlage = self.setObjToSave(key, values);
        return lastValueFrom(self._ajaxService.post('api/Wiedervorlagen/Save', wiedervorlage)).then((response) => {
          return lastValueFrom(self._ajaxService.post<IWiedervorlageViewModel[]>('api/Wiedervorlagen/Get', { ownerId: self.ownerId, entityArt: self.entityArt })).then(
            (response) => {
              return {
                data: response,
                totalCound: response.length,
              };
            }
          );
        });
      },
      remove: function (key) {
        return lastValueFrom(self._ajaxService.post('api/Wiedervorlagen/Remove', key.id)).then((response) => {});
      },
    });
  }

  private setObjToSave(data: IWiedervorlageViewModel, values): any {
    const v = Object.keys(values);
    for (const item of v) {
      if (data.hasOwnProperty(item)) {
        data[item] = values[item];
      }
    }
    return data;
  }

  onInitNewRow(e) {
    e.data.benutzerId = +this.currentUserId;
  }

  addCustomItem(item) {
    const viewmodel = { bezeichnung: item.text };
    return lastValueFrom(this._ajaxService.post('api/Wiedervorlagen/AddGrund', viewmodel));
  }

  allowEdit(e) {
    return e.row.data.canEdit;
  }

  onOnlySelfResultsValueChanged(event) {
    this.onlySelfResults = event.value;
    this.dataSource.reload();
  }

  onContentReady(e) {
    e.component.columnOption('command:edit', {
      visibleIndex: -1,
    });
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;
    const searchPanel = toolbarItems.filter((item) => item.name === 'searchPanel');

    if (searchPanel && searchPanel[0]) {
      searchPanel[0].location = 'before';
    }

    e.toolbarOptions.items.push({
      location: 'before',
      template: 'searchBarTemplate1',
    });
  }
}
